/**
 * MOB (man overboard) actions — the one path both the HUD button and the Safety
 * menu use, so there's a single place that decides what "drop a MOB" means.
 *
 * Dropping a MOB writes a mark at the vessel's current position into the safety
 * store. That store is the source of truth the map's safety layer reads, so the
 * mark is drawn straight away and, because it lives in the store rather than only
 * on the map, it survives a WebGL context loss and the boat-icon self-heal (the
 * layer is re-added from the store on every style reload). Clearing sets it back
 * to null, which removes the mark and ends the return.
 */
import { useChartPlotterStore } from '@/store';
import { useSafetyStore } from '@/store/safety';
import { useMobSearchStore } from '@/store/mobSearch';

/**
 * Drop a MOB mark at the vessel and enter the return (the mark the safety layer
 * and the drift calc read). Returns false when there's no fix yet, so the caller
 * can say so rather than pretend a mark was dropped.
 */
export function dropMobAtVessel(): boolean {
  const pos = useChartPlotterStore.getState().ownship.position;
  if (!pos) return false;
  useSafetyStore.getState().setMob({ position: pos, droppedAt: Date.now() });
  // A fresh MOB starts a fresh search: wipe any inputs left from a previous one.
  useMobSearchStore.getState().reset();
  return true;
}

/** Clear the active MOB mark, ending the return. */
export function clearMob(): void {
  useSafetyStore.getState().setMob(null);
  useMobSearchStore.getState().reset();
}
